




























































import {defineComponent, PropType} from '@vue/composition-api';
import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import {VTextField} from 'vuetify/lib/components';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default defineComponent({
  name: 'uOttawa1321Prelab5Question3',
  components: {StembleLatex, STextarea, VTextField},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        aiQuestionResponse: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      questions: [
        {
          en: 'What is the name of the cationic intermediate formed during the halogenation of an alkene?',
          fr: "Quel est le nom de l'intermédiaire cationique formé pendant l'halogénation d'une alcène ?",
        },
      ],
    };
  },
  methods: {
    getQuestionText(question: any): string {
      return this.inputs.language === 'en' ? question.en : question.fr;
    },
  },
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/ottawaPrelab5Q3.png');
    },
    imageNameFr(): string {
      return prefixPublicAsset('/img/assignments/ottawaPrelab5Q3Fr.png');
    },
  },
});
